import { FC } from 'react'
import _ from 'lodash'
import useTranslate from '../../../i18n/useTranslate'
import { makeStyles } from '@material-ui/core'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { DataRowsType } from '../../../services/um/useSearchHold'
import CustomPagination from '../closed/CustomPagination'
import CustomNoRowsOverlay from '../closed/CustomNoRowsOverlay'
import { CustomSortingASCcending, CustomSortingDescending } from '../closed/CusromSorting'

type HoldDataTableComponentProps = {
    dataList: DataRowsType[]
}

const DataTable: FC<HoldDataTableComponentProps> = ({ dataList }) => {
    const classes = useStyles()
    const translate = useTranslate()

    const column: GridColDef[] = [
        {
            field: 'projectNumber',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN1')}`,
            width: 180,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'receiveDate',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN2')}`,
            width: 150,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'countDueDate',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN3')}`,
            width: 200,
            headerClassName: 'header-table',
            headerAlign: 'left',
            align: 'center',
        },
        {
            field: 'projectType',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN4')}`,
            width: 300,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'researcherName',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN5')}`,
            width: 300,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'researcherTypeName',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN6')}`,
            width: 200,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'faculty',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN7')}`,
            width: 300,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'degree',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN8')}`,
            width: 200,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'projectNameTH',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN9')}`,
            width: 300,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
        {
            field: 'projectNameEN',
            headerName: `${translate.get('UM.HOLD.DATA_TABLE.COLUMN10')}`,
            width: 300,
            headerClassName: 'header-table',
            headerAlign: 'left',
        },
    ]

    return (
        <div style={{ width: '100%', marginTop: 16 }}>
            <DataGrid
                className={classes.root}
                rows={dataList}
                columns={column}
                ///pagination
                autoHeight={true}
                pagination
                pageSize={10}
                rowsPerPageOptions={[10]}
                sortingOrder={['asc', 'desc']}
                disableColumnMenu={true}
                disableSelectionOnClick={true}
                components={{
                    Pagination: CustomPagination,
                    NoRowsOverlay: CustomNoRowsOverlay,
                    // ColumnSortedDescendingIcon: CustomSortingDescending,
                    // ColumnSortedAscendingIcon: CustomSortingASCcending,
                }}
            />
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        '& .super-app-theme--fffff': {
            backgroundColor: '#DB5F8E',
            '&:hover': {
                backgroundColor: '#DB5F8E',
            },
        },
        '& .super-app-theme--header': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
        '& .MuiDataGrid-columnSeparator': {
            visibility: 'hidden',
        },
        '& .MuiDataGrid-row': {
            lineHeigh: '70px',
        },

        '& .header-table': {
            backgroundColor: '#DB5F8E',
            color: '#FFFFFF',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-sortIcon': {
            color: '#FFFFFF',
        },
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            display: 'none',
        },
        '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        '& .MuiDataGrid-row, .MuiDataGrid-root .MuiDataGrid-cell, .rendering-zone': { 'max-height': 'none !important' },
        '.MuiDataGrid-root .MuiDataGrid-window': { position: 'relative !important' },
        '.MuiDataGrid-root .MuiDataGrid-viewport': { 'max-height': 'none !important' },
        '.MuiDataGrid-root': { height: 'auto !important' },
        width: '100%',
        marginTop: 16,

        overflowX: 'hidden',
    },
}))

export default DataTable
